/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowOpenRight16: {
  name: 'arrow-open-right-16';
  data: string;
} = {
  name: 'arrow-open-right-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2.322 8.954 9 8l-6.679-.954a.5.5 0 0 1-.41-.358L.625 2.186a1 1 0 0 1 1.408-1.17l12.178 6.09a1 1 0 0 1 0 1.788l-12.177 6.09a1 1 0 0 1-1.409-1.17L1.912 9.31a.5.5 0 0 1 .41-.357z"/></svg>`
};
